export { default } from './InputSearch';
